export default [
  {
    route: '/',
    title: 'dashboard',
    icon: 'HomeIcon',
    i18n: 'Mural',
    rule: 'dashboard'
  }
]
